import { EventEmitter, Injectable } from "@angular/core";
import { EasyFormService } from "src/app/services/easy-form-service";
import { EasyNotificationService } from "src/app/services/easy-notification.service";
import { HcrService } from "src/app/services/hcr-service.service";
import { CsHis6HCStatusEnum, CsHis6HCTypeEnum, CsHis6HPCStatusEnum, VisionHIS6 } from "../hcr-lib/VisionHIS6";
import { MainLayoutService } from "src/app/layout/services/main-layout.service";
import { CSHISResult } from "../hcr-lib/CSHISResult";
import { UserConfirmService } from "src/app/services/user-confirm.service";
import { IcHelper } from "./ic-helper";
import { BaseConfig } from "src/app/services/base-config.service";

@Injectable({
  providedIn: 'root'
})
/** 虛擬健保卡狀態幫手 */
export class VICHelper {
    //isVICInserted:boolean;
    onClear = new EventEmitter();
    constructor(
        //private icHelper:IcHelper,
        private mainlayoutService:MainLayoutService,
        private userConfirm:UserConfirmService,
        private hcrService:HcrService,
        private notification:EasyNotificationService,
    ) {

    }
    private isCsHis6(){
        return this.hcrService.IsVer6;
    }
    private getAPI(){
        return this.hcrService.VisionApi as VisionHIS6;
    }
    public async IsVICEnabled(){
      //return this.isVHCHostEnabled||this.isCsHis6();
      return await this.isCsHis6();
    }
    public async CheckVICInserted(){
      
        if(await this.isCsHis6()){
          var api = this.hcrService.VisionApi as VisionHIS6;
          var st = await api.GetCardStatusAll();
          return  st.status.hc.status > CsHis6HCStatusEnum.未置入健保卡 
                            && st.status.hc.type== CsHis6HCTypeEnum.虛擬卡;
        }
      
      return false;
    }
    async openVHCReader():Promise<boolean>{
      var code = await this.readQr();
      this.mainlayoutService.closeQRCodeScanner();
      return !!code;
    }
    /** 取得患者虛擬健保卡授權並載入 */
    async RequestToken(patientCId:string):Promise<boolean>{
      var api = this.getAPI();
      if(!(api instanceof VisionHIS6)){
        this.notification.showError('需啟動雲端控制軟體6.0版以上才可使用虛擬健保卡功能');
        return false
      }
      var accessToken = await api.VirtualHcRequestToken(patientCId);
      if(accessToken.StatusCode!=0){
        this.notification.showError('請求虛擬健保卡授權失敗('+ accessToken.ErrorMsg+')');
        return false
      }
      var ret = await this.userConfirm.showConfirm({
        title:'等候回應中',
        msg:'待患者授權完畢後，點選繼續。或者取消中止等候。',
        textNo:'取消',
        textYes:'繼續'
      })
      if(ret){
        var token = await api.VirtualHcResponseToken(accessToken.Data);
        if(token.StatusCode!=0){
          this.notification.showError('取得虛擬健保卡授權失敗('+ accessToken.ErrorMsg+')');
          return false
        } 
        var qrCodeRet = await api.VirtualHc(token.Data);
        if(qrCodeRet.StatusCode!=0){
          this.notification.showError('虛擬健保卡授權載入失敗('+ accessToken.ErrorMsg+')');
          return false
        }
        return true; 
      }
      return false
    }
    /** 開啟QRCode掃描 並載入虛擬健保卡 */
    async readQr():Promise<boolean>{
      //攝影機
      //var code = await this.mainlayoutService.openQRCodeScanner();
      //條碼槍
      var code = await this.mainlayoutService.openQRCodeReader();
      if(code==''){
        return false;
      }
      var ret:CSHISResult = null;
      var api = this.getAPI();
      if(api instanceof VisionHIS6){
        ret = await api.VirtualHc(code)
      }else{
        this.notification.showError('需啟動雲端控制軟體6.0版以上才可使用虛擬健保卡功能');
        return false
      }
      
      if(ret.StatusCode!=0){
        this.notification.showError(ret.ErrorMsg);
        // 掃出來的載不進去再重新一次
        return await this.readQr() 
      }else{
        await this.mainlayoutService.closeQRCodeReader();
        return true;
      }
    }
    
    async clearVHC(){
      var api = this.getAPI();
      if(api instanceof VisionHIS6){
        var ret = await api.VirtualHcLogout();
        if(ret.StatusCode!=0){
          this.notification.showError(ret.ErrorMsg);
        }else{
          this.onClear.emit();
          this.notification.showSuccess(ret.ErrorMsg);
        }
      }else{
          this.notification.showError('需啟動雲端控制軟體6.0版以上才可使用虛擬健保卡功能');
          return
      }
    }
    async TryClearVHC(){
      try{
        var api = this.hcrService.VisionHis6;
        if(api){
          if((await api.VirtualHcLogout()).StatusCode==0){
            this.onClear.emit();
          }
        }
      }catch{}
      
    }
}
